import React from 'react';

const IdCardSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 7h7v12H3V7h7v1H9v1h6V8h-1V7zm-3 1h2V5h-2v3zm-1-4v2H2v14h20V6h-8V4h-4z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 15h5v1h-5zM13 13h3v1h-3zM13 11h5v1h-5zM5 11v5h5v-5H5zm4 4H6v-3h3v3z"
        />
    </svg>
);

IdCardSvg.displayName = 'IdCardSvg';
export default IdCardSvg;
